import api from './client';
import type { Agent } from '../types';

export interface CreateAgentPayload {
  workspaceId: string;
  name: string;
  displayName: string;
  roleTitle?: string;
  description: string;
  systemPrompt: string;
  model: string;
  temperature: number;
  status: Agent['status'];
  clientApiBaseUrl?: string;
  clientApiToken?: string;
  identityResolverEndpoint?: string;
  customerSystemPrompt?: string;
  customerModeEnabled?: boolean;
}

export interface UpdateAgentPayload {
  name?: string;
  description?: string;
  systemPrompt?: string;
  model?: string;
  status?: Agent['status'];
  clientApiBaseUrl?: string;
  clientApiToken?: string;
  identityResolverEndpoint?: string;
  serviceUrls?: Record<string, string> | null;
  customerSystemPrompt?: string;
  customerModeEnabled?: boolean;
  adminAlertPhoneNumber?: string | null;
  elevenLabsAgentId?: string | null;
}

export const fetchAgents = async (workspaceId: string): Promise<Agent[]> => {
  if (!workspaceId || workspaceId === 'undefined' || workspaceId === 'null') {
    throw new Error('Invalid workspaceId');
  }
  const { data } = await api.get<Agent[]>('/agents', {
    params: { workspaceId },
  });
  return data;
};

export const createAgent = async (
  payload: CreateAgentPayload,
): Promise<Agent> => {
  const { data } = await api.post<Agent>('/agents', payload);
  return data;
};

export const fetchAgent = async (id: string): Promise<Agent> => {
  const { data } = await api.get<Agent>(`/agents/${id}`);
  return data;
};

export const updateAgent = async (
  id: string,
  payload: UpdateAgentPayload,
): Promise<Agent> => {
  const { data } = await api.patch<Agent>(`/agents/${id}`, payload);
  return data;
};

export interface UpdateAgentAvatarPayload {
  avatarType: 'UPLOADED' | 'URL' | 'GENERATED';
  avatarUrl?: string;
  avatarStyle?: string;
}

export const updateAgentAvatar = async (
  id: string,
  payload: UpdateAgentAvatarPayload,
): Promise<Agent> => {
  const { data } = await api.post<Agent>(`/agents/${id}/avatar`, payload);
  return data;
};

export const deleteAgent = async (id: string): Promise<void> => {
  await api.delete(`/agents/${id}`);
};

